module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("lU5P0"))).then(() => parcelRequire('ljYL6'));